import { apis, uploadFileToS3 } from 'probonio-shared-ui/module/api';

export async function uploadCustomBenefitImageFile(tenantId: string, mimetype: string, imageFile: Blob): Promise<string> {
  const uploadLink = await apis.customBenefits.createUploadLink({ tenantId }).then(res => res.data);
  await uploadFileToS3(uploadLink, imageFile, mimetype);
  return uploadLink.key;
}
